import { getPrice2decimal } from './convertor'
import { getLoanDisplayNo } from './getLoanDisplayNo'
import { getPartiesMap } from './validator'

/** Default matches the former hard-coded Loan Overview copy / note subject. */
export const DEFAULT_OVERVIEW_COPY_TEMPLATE =
  '{LoanNumber} | {EntityName} | {BorrowerName} | {SubjectPropertyAddress}'

export type OverviewIdentitySource = {
  loanNumber?: number | string
  byteproFileName?: number | string
  /** Prefer Borrowing Entity company when present (same as Overview copy today). */
  borrowingEntityName?: string
  entityTitle?: string
  borrowerName?: string
  propertyAddress?: string
  proposedLoanAmount?: number | string
  loanAmount?: number | string
  program?: string
  loanProgram?: string
  loanStatus?: string
  productType?: string
  closingDate?: string
  mers?: string
}

/** Placeholder keys available when editing the Overview copy template. */
export const getOverviewCopyPlaceholders = (): string[] => {
  const keys = Object.keys(getPartiesMap({}))
  if (!keys.includes('EntityName')) keys.push('EntityName')
  return keys.sort((a, b) => a.localeCompare(b))
}

export const buildOverviewIdentityPlaceholders = (detail: OverviewIdentitySource): Record<string, string> => {
  const loanAmountRaw = detail.loanAmount ?? detail.proposedLoanAmount
  const loanAmount =
    loanAmountRaw === '' || loanAmountRaw == null || loanAmountRaw === undefined
      ? ''
      : getPrice2decimal(loanAmountRaw, false, true)

  return {
    ...getPartiesMap({}),
    LoanNumber: getLoanDisplayNo(detail),
    EntityName: detail.borrowingEntityName || detail.entityTitle || '',
    BorrowerEntityTitle: detail.entityTitle || '',
    BorrowerName: detail.borrowerName || '',
    SubjectPropertyAddress: detail.propertyAddress || '',
    LoanAmount: loanAmount,
    '120%LoanAmount': loanAmount
      ? getPrice2decimal(Number(String(loanAmount).replace(/,/g, '')) * 1.2, false, true)
      : '',
    LoanProgram: detail.program || detail.loanProgram || '',
    LoanStatus: detail.loanStatus || '',
    ProductType: detail.productType || '',
    ClosingDate: detail.closingDate || '',
    Mers: detail.mers || '',
  }
}

/** Resolve `{Placeholder}` tokens (single braces) using overview identity values. */
export const resolveOverviewCopyTemplate = (
  template: string | undefined | null,
  detail: OverviewIdentitySource,
): string => {
  const values = buildOverviewIdentityPlaceholders(detail)
  const raw = (template && String(template).trim()) || DEFAULT_OVERVIEW_COPY_TEMPLATE
  return raw.replace(/\{([A-Za-z0-9_%]+)\}/g, (_, key: string) => {
    if (values[key] === undefined || values[key] === null) return ''
    return String(values[key])
  })
}
